import pinMapa from '../img/sections/Ubicacion/pinMapa.svg';

export const mapPin = pinMapa;
export const GOOGLE_API_KEY = 'AIzaSyAW_ct6DuqszSMZo2GuBykyZTY2Bb4rQHY';
export const API_URL_QC = 'https://apiproduccionaz.quierocasa.com.mx:7007/';//Api Prod QC